import Meta from '@/components/common/Meta'

import LegalDocumentStorageForLawFirmsPage from '@/v2/components/pages/landing-pages/legal-document-storage-for-law-firms-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/legal-document-storage-for-law-firms-page'

interface LegalDocumentStorageForLawFirmsPageProps {}

const Page: React.FC<LegalDocumentStorageForLawFirmsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.legal_document_storage_for_law_firms.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.legal_document_storage_for_law_firms?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.legal_document_storage_for_law_firms?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <LegalDocumentStorageForLawFirmsPage />
    </>
  )
}

export default Page
